import { useUserStore } from 'es/app/store/GlobalStore';

export const useActiveSite = () => {
    const userStore = useUserStore();
    return userStore.activeSite;
};

export const useActiveFacility = () => {
    const userStore = useUserStore();
    return userStore.activeFacility;
};

export const useCompaniesAndFacilities = () => {
    const userStore = useUserStore();

    return {
        companies: userStore.accessibleCompanies,
        facilities: userStore.accessibleFacilities,
    };
};
